import { Pipe, PipeTransform } from '@angular/core';
import {TemplateDefinition} from '../model/template-definition';
import {ComponentType} from '../model/component-type.enum';
import {ProductLine} from '../model/product-line.enum';
import {Template} from '../model/template';
import {TemplateProductLine} from '../model/template-product-line';

@Pipe({
  name: 'templatesByComponentType'
})
export class TemplatesByProductLinePipe implements PipeTransform {

  transform( templates: Template[], productLine: TemplateProductLine ): Template[] {
    if (!templates || !productLine) {
      return templates;
    }

    return templates.filter( t => t.productLine === productLine.code );
  }

}
